import Container from './GallectionLayout.container';
import GallectionLayout from './GallectionLayout';

export default Container(GallectionLayout);
